<div class="no-internet-container">
  <div class="no-internet-content">
    <h1>No Internet Connection</h1>
    <p>Please check your internet connection and try again.</p>
    <button mat-raised-button color="primary" (click)="tryAgain()">Try Again</button>
  </div>
</div>